<div class="row">
  <div class="col-sm-9">
    <div class="booking_ht">
      <!-- <sm-title-bar pageTitle="All expenditure"></sm-title-bar> -->
      <sm-title-bar pageTitle="All expenditure" [showBackToDashboard]="true"></sm-title-bar>
    </div>
  </div>
  <div class="col-sm-3">
    <!-- <div class="search_bar_custom">
      <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search for services">
          <button mat-icon-button matSuffix>
              <mat-icon>search</mat-icon>
          </button>
      </mat-form-field>
  </div> -->
  </div>
</div>


<div class="expenside_tht row" *ngIf="!loader">
  <div class="col-md-6 col-sm-6 col-12" *ngFor="let data  of expenditureData">
  <mat-card >
    <div class="all_expenture_head">
      <div class="ada_her">
      <div class="bookign_crim">
       <mat-icon *ngIf="data.expense_type == 1">receipt</mat-icon>
       <mat-icon *ngIf="data.expense_type == 2">local_mall</mat-icon>
       <mat-icon *ngIf="data.expense_type == 3">payments</mat-icon>
    </div>
    </div>
    <div class="plan-card" >
      <h2 class="plan-title"> {{ data.price }}</h2>
      <p class="plan-info">
        <span class="label_expem">{{data.expense_label}}</span>, <span class="label_expem">{{ data.expense_detail }} </span>
      </p>
     
    </div>
    </div>
      <div class="sb_plan_card">
      <p class="plan-cost">
        <span class="label_business">{{data.name}}</span>
      </p>
      <p> <span class="value">{{ data.address_line }} </span></p>
      <p class="datetimexd">
        <span class="label" style="color: #888;">{{data.expense_datetime | date: 'MMM d, y, h:mm a' : 'UTC'}}</span>
      </p>
    </div>
  </mat-card>
  </div>
</div>


<!-- <mat-card appearance="outlined" *ngIf="!loader && expenditureData.length > 0">
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumns" [showImageColumn]="true" [imageTemplate]="image"
      [dataSource]="expenditureData" [showPagination]="true" [itemsPerPage]="25">
    </sm-data-table>
  </div>
</mat-card>


<ng-template #menuTemplate let-rowvalue>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">edit</mat-icon>
    <span>edit</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">delete</mat-icon>
    <span>Delete</span>
  </button>
</ng-template>
<ng-template #image let-objValue>
  <div class="bookign_crim">
    <mat-icon *ngIf="objValue['expense_type'] == 1">receipt</mat-icon>
    <mat-icon *ngIf="objValue['expense_type'] == 2">local_mall</mat-icon>
    <mat-icon *ngIf="objValue['expense_type'] == 3">payments</mat-icon>
  </div>
</ng-template> -->